import Cookies, { CookieAttributes } from 'js-cookie'
import {
  REACT_APP_COOKIE_DOMAIN,
  REACT_APP_PARENT_APP_DOMAIN,
} from 'utils/constants/environment'

export const getCookie = (key: string, option?: any) => {
  try {
    // @ts-ignore

    return JSON.parse(Cookies.get(key, option))
  } catch (error) {
    return null
  }
}

function normalizeDomainSegment(host: string): string {
  return host.replace(/^\./, '').trim()
}

/**
 * Options for access/refresh token cookies.
 * - By default, sets `domain=.${parent}` only when the page hostname is the
 *   apex or a subdomain of `REACT_APP_PARENT_APP_DOMAIN` (e.g. *.egs-dev.local).
 *   Tunnels (ngrok, etc.) get host-only cookies so auth works on that host.
 * - `REACT_APP_COOKIE_DOMAIN`: optional override — `''`, `host`, or `__host__`
 *   forces host-only; any other value forces that cookie domain (with leading dot).
 * - `secure` is set when the app is served over HTTPS (e.g. ngrok).
 */
export function getAuthCookieOptions(): CookieAttributes {
  const opts: CookieAttributes = { path: '/' }

  const override = REACT_APP_COOKIE_DOMAIN
  if (override !== undefined) {
    const o = override.trim().toLowerCase()
    if (o === '' || o === 'host' || o === '__host__') {
      // host-only — omit domain
    } else {
      opts.domain = o.startsWith('.')
        ? o
        : `.${normalizeDomainSegment(override)}`
    }
  } else {
    const parent = normalizeDomainSegment(REACT_APP_PARENT_APP_DOMAIN || '')
    if (
      typeof window !== 'undefined' &&
      parent &&
      (window.location.hostname === parent ||
        window.location.hostname.endsWith(`.${parent}`))
    ) {
      opts.domain = `.${parent}`
    }
  }

  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    opts.secure = true
  }

  return opts
}

export const setCookie = (
  name: string,
  token?: any,
  options?: CookieAttributes
) => {
  if (!!token) {
    Cookies.set(
      name,
      JSON.stringify(token),
      options ?? {
        expires: 60 * 60 * 24 * 30,
        //domain: APP_DOMAIN
      }
    )
  } else {
    Cookies.remove(name, {
      //domain: APP_DOMAIN
    })
  }
}

export const deleteCookie = (name: string) => {
  Cookies.remove(name, {
    //domain: APP_DOMAIN
  })
}
